import React, { useState } from "react";
import {
  TableCell,
  TableRow,
  Collapse,
  Table,
  TableBody,
  FormControl,
  TextField,
} from "@material-ui/core";

import { routes } from "@utils/constant";
import { formatAustralianCurrency, utcToTimezone } from "@utils/commonFunctions";
import { Link } from "react-router-dom";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { enAU } from "date-fns/locale";
import calendarIcon from "@assets/images/calendar-icon.svg";
import { TableStyle } from "./style";
import moment from "moment";

function Row(props) {
  const [open, setOpen] = useState(false);
  const classes = TableStyle();
  const { row, timezone } = props;
  let listJobs = row?.newInvoiceId
    ? row?.impactedTargetInvoices?.jobs
    : row?.impactedSourceInvoices?.jobs || [];
  const handleAccordian = () => {
    setOpen(!open);
  };

  return (
    <>
      <TableRow onClick={handleAccordian} className="accordian-row">
        <TableCell className="invoice">
          #{row?.invoiceId}
        </TableCell>
        <TableCell className="invoiceDate">
          {row?.impactedSourceInvoices?.invoiceDate
            ? moment(row.impactedSourceInvoices.invoiceDate).format("DD-MM-YYYY")
            : "-"}
        </TableCell>
        <TableCell className="job"></TableCell>
        <TableCell className="jobDate"></TableCell>
        <TableCell className="previousRate"></TableCell>
        <TableCell className="originalJobCharge"></TableCell>
        <TableCell className="newJobCharge"></TableCell>
        <TableCell className="difference"></TableCell>
        <TableCell className="originalInvoiceAmount">{row?.impactedSourceInvoices?.net ? formatAustralianCurrency(row?.impactedSourceInvoices?.net) : "-"}</TableCell>
        <TableCell className="newInvoice">
          {row?.newInvoiceId ? `#${row?.newInvoiceId}` : "-"}
        </TableCell>
        {row?.impactedTargetInvoices?.invoiceDate ? (
          <TableCell className="newInvoiceDateText">{moment(row?.impactedTargetInvoices?.invoiceDate).format("DD-MM-YYYY")}</TableCell>
        ) : (
          <TableCell
            className="newInvoiceDateInput"
            onClick={(e) => e.stopPropagation()}
            ref={(el) => {
              if (el && props.listNewInvoiceDateMap?.get(row?.invoiceId)?.errorDate) {
                props.registerErrorRef(row?.invoiceId, el);
              }
            }}
          >
            <FormControl variant="outlined" className={classes.formControl}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={enAU}>
                <KeyboardDatePicker
                  variant="inline"
                  format="dd/MM/yyyy"
                  className="custom-datepicker"
                  keyboardIcon={<img src={calendarIcon} alt="calendar" />}
                  name="startDate"
                  placeholder="DD/MM/YYYY"
                  value={props.listNewInvoiceDateMap?.get(row?.invoiceId)?.date ?? null}
                  onChange={(e) => props.handleChangeInvoiceDate(e, row?.invoiceId)}
                  onClick={(e) => e.stopPropagation()}
                  autoOk
                  error={true}
                  helperText={props.listNewInvoiceDateMap?.get(row?.invoiceId)?.errorDate ?? ""}
                  TextFieldComponent={(props) => (
                    <TextField
                      {...props}
                      InputProps={{
                        ...props.InputProps,
                        readOnly: true,
                      }}
                    />)}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </TableCell>
        )}
        <TableCell className="newInvoiceAmount">{row?.newInvoiceId ? formatAustralianCurrency(row?.impactedTargetInvoices?.net) : "-"}</TableCell>
        <TableCell className="differenceAmountInvoice">{row?.newInvoiceId ? formatAustralianCurrency(row?.impactedTargetInvoices?.net - row?.impactedSourceInvoices?.net) : "-"}</TableCell>
      </TableRow>
      <TableRow className="sub-row">
        <TableCell className="MuiTableSubRoW" colSpan={13}>
          <Collapse in={open}>
            <Table stickyHeader aria-label="simple table">
              <TableBody>
                {listJobs?.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className="invoice"></TableCell>
                      <TableCell className="invoiceDate"></TableCell>
                      <TableCell className="job">
                        <Link to={`${routes.jobDetail}/${item?.id}`} target="_blank">
                          {item?.id}
                        </Link>
                      </TableCell>
                      <TableCell className="jobDate">{utcToTimezone(item.completedAt, timezone, "DD-MM-YYYY")}</TableCell>
                      <TableCell className="previousRate">{item?.impactedJobs[0]?.fuelSurcharges?.fuelSurcharge ?? "0"}%</TableCell>
                      <TableCell className="originalJobCharge">{Number(item?.impactedJobs?.[0]?.originalCharge) === 0 ? "-" : formatAustralianCurrency(item?.impactedJobs[0]?.originalCharge)}</TableCell>
                      <TableCell className="newJobCharge">{item?.impactedJobs[0]?.isReCalculated ? formatAustralianCurrency(item?.net) : "-"}</TableCell>
                      <TableCell className="difference">{item?.impactedJobs[0]?.isReCalculated ? formatAustralianCurrency(item?.net - item?.impactedJobs[0]?.originalCharge) : "-"}</TableCell>
                      <TableCell className="originalInvoiceAmount"></TableCell>
                      <TableCell className="newInvoice"></TableCell>
                      <TableCell className={row?.impactedTargetInvoices?.invoiceDate ? "newInvoiceDateText" : "newInvoiceDateInput"}></TableCell>
                      <TableCell className="newInvoiceAmount"></TableCell>
                      <TableCell className="differenceAmountInvoice"></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
